import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import header   from './views/header'
import footer   from './components/footer'

import VueCarousel from 'vue-carousel';

import HighchartsVue from 'highcharts-vue';

Vue.use(HighchartsVue);

Vue.use(VueCarousel);
Vue.component('app-header', header);
Vue.component('app-footer', footer);



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
